import React from 'react';
import styled from 'styled-components';
import { SectionParent, B1, BlueButton } from '../../StyledComponents';
import { navigate } from '@reach/router';
import { BottomBanner } from '../BottomBanner';
import { StaticQuery, graphql } from 'gatsby';
import GatsbyImage from 'gatsby-image';

const Section = styled(SectionParent)`
  background: #ffffff;
  padding-top: 0rem !important;
  padding-bottom: 0rem !important;
  @media (max-width: 520px) {
    padding-top: 0rem !important;
    padding-bottom: 0rem !important;
  }
`;

const Grid = styled.div`
  display: grid;
  margin-top: 3rem;
  @media (min-width: 520px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 520px) {
    margin-top: 3rem;
  }
`;

const GridItem = styled.div`
  justify-self: start;
  max-width: 100%;
  grid-column: span 2;
  align-self: center;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    margin-left: 5rem;
  }
  @media (max-width: 520px) {
    grid-column: span 1;
    margin-bottom: 3rem;
    padding-bottom: 0rem;
    display: grid;
    margin-left: 0rem;
    justify-items: center;
  }
`;
const GridItemRight = styled.div`
  justify-self: center;
  max-width: 100%;
  grid-column: span 2;
  align-self: center;
  padding-bottom: 2rem;
  @media (max-width: 768px) {
    margin-right: 5rem;
  }
  @media (max-width: 520px) {
    grid-column: span 1;
    margin-bottom: 3rem;
    padding-bottom: 0rem;
    display: grid;
    margin-right: 0rem;
    justify-items: center;
  }
`;

const SectionLeftImage = styled(GatsbyImage)`
  max-width: 250px;
  width: 80%;
  justify-self: end;
  @media (max-width: 520px) {
    margin-left: 0rem;
  }
`;
const SectionRightImage = styled(GatsbyImage)`
  max-width: 250px;
  width: 80%;
  justify-self: center;
  @media (max-width: 520px) {
    display: none;
  }
`;
const SectionRightImageMobile = styled(GatsbyImage)`
  max-width: 250px;
  width: 80%;
  justify-self: center;
  @media (min-width: 521px) {
    display: none;
  }
`;
const SectionSubHeading = styled.div`
  padding-top: 1rem;

  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #725cbd;
  @media (max-width: 520px) {
    text-align: center;
  }
`;
const SectionSubHeadingRight = styled.div`
  padding-top: 1rem;

  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  padding-left: 6rem;
  line-height: normal;
  letter-spacing: normal;
  color: #725cbd;
  @media (max-width: 520px) {
    text-align: center;
    padding-left: 0;
  }
`;

const SectionContent = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 80%;
  color: #6a718c;

  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    width: 90%;
  }
`;

const SectionContentSecond = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 100%;
  padding-left: 6rem;
  color: #6a718c;
  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    padding-left: 0;
    text-align: center;
    width: 90%;
  }
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  padding-right: 3rem;
  @media (max-width: 520px) {
    gitppadding-right: 4rem;
  }
`;
const BlueButtonWrapperNew = styled.div`
  margin-bottom: 3rem;
  padding-left: 5.4rem;
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
    margin-bottom: 0;
    padding-left: 0;
  }
`;
export default () => (
  <StaticQuery
    query={graphql`
      query {
        virtual: file(relativePath: { eq: "v2/Test/virtual-lab.png" }) {
          childImageSharp {
            fluid(quality: 85) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }

        deviceLab: file(relativePath: { eq: "v2/Test/tab.png" }) {
          childImageSharp {
            fluid(quality: 85) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }
      }
    `}
    render={(data: any) => (
      <div>
        <Section>
          <Grid>
            <ImgWrapper>
              <SectionLeftImage
                fluid={data.deviceLab.childImageSharp.fluid}
                loading="lazy"
                alt="auto deploy"
              />
            </ImgWrapper>
            <GridItem>
              <SectionSubHeading>Set Up Your Device Lab</SectionSubHeading>
              <SectionContent>
                Configure a group of target devices in your lab using Esper and
                then deploy and test applications on them. You can use{' '}
                <a
                  href="https://docs.esper.io/home/espercli.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#5cbd9a',
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                >
                  {' '}
                  the Esper command line tools
                </a>{' '}
                and our{' '}
                <a
                  href="https://docs.esper.io/home/esperplugin.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#5cbd9a',
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                >
                  {' '}
                  Android Studio plugin
                </a>{' '}
                to deploy the applications and change settings on-the-fly.
              </SectionContent>
            </GridItem>
          </Grid>
          <Grid>
            <GridItemRight>
              <SectionRightImageMobile
                fluid={data.virtual.childImageSharp.fluid}
                loading="lazy"
                alt="lock"
              />
              <SectionSubHeadingRight>
                Virtual Device Lab
              </SectionSubHeadingRight>
              <SectionContentSecond>
                Run instances of custom virtual devices in the cloud to stress
                test application instances and backend services running on
                hundreds of devices. Virtual devices are customized to the
                hardware and OS configuration of target devices.
              </SectionContentSecond>
              <BlueButtonWrapperNew>
                <BlueButton
                  id="test__learn_more"
                  onClick={() => navigate('/android-virtual-device/')}
                >
                  {' '}
                  Learn More
                </BlueButton>
              </BlueButtonWrapperNew>
            </GridItemRight>
            <ImgWrapper>
              <SectionRightImage
                fluid={data.virtual.childImageSharp.fluid}
                loading="lazy"
                alt="lock device"
              />
            </ImgWrapper>
          </Grid>
        </Section>
        <BottomBanner
          description={`Run your app on a virtual device to check performance and behavior`}
          buttonText={`Sign Up`}
          link="https://esper.io/signup"
        />
      </div>
    )}
  />
);
